import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Redirect, useLocation } from "react-router-dom";
import OtpScreen from "../components/OtpScreen";
import SignupForm from "../components/sections/SignupForm";
import queryString from "query-string";
import HelmetWrapper from "../components/sections/HelmetWrapper";
import { signupMetaData } from "../seo/metaDeta";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const Signup = () => {
  const isLoggedIn = useSelector((store) => store.auth.loggedIn);
  const [otp, setOtp] = useState(null);
  const location = useLocation();
  const history = useHistory();
  const { error } = queryString.parse(location.search);
  const [signupError, setsignupError] = useState(error ? error : null);

  if (isLoggedIn) {
    return <Redirect to={"/dashboard"} />;
  }

  return (
    <>
      <HelmetWrapper {...signupMetaData} />
      <div className="signup-box">
        <div className="signup-img">
          <div className="signup-static">
            <img
              src={require("../assets/images/datazip.svg")}
              alt="datazip-logo"
              className="image cursor-pointer"
              onClick={() => history.push("/")}
            />
            <div className="heading">Decision Intelligence, reimagined.</div>
            <div className="subHeading">
              Powerful, self-serve analytics tool to help business teams answer
              simple to complex questions in minutes, not days or months
            </div>
            <div className="signup-video">
              <iframe
                src="https://www.youtube.com/embed/Ejg6IlF4e5Q?si=kVK4n30WYE0irDw9"
                title="Datazip - Product Demo October 2022"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
          </div>
        </div>
        <div className="signup-cta">
          {otp ? (
            <OtpScreen email={otp} />
          ) : (
            <SignupForm
              setOtp={setOtp}
              error={signupError}
              setError={setsignupError}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default Signup;
